import { createContext } from 'react'

import { BidMemberListModalStore } from './interface'

export const BidMemberListModalStoreContext = createContext<
  BidMemberListModalStore | undefined
>(undefined)
